export default () => ({
    headerCheck: false
})